import {toast} from "react-hot-toast";
import {useGoogleLogin} from "@react-oauth/google";

export const useSignUpWithGoogle = (googleSubmit: any) => {
  const signUpWithGoogle = useGoogleLogin({
    flow: "auth-code",
    scope: "email profile openid",
    onSuccess: async (codeResponse) => {
      googleSubmit({
        grantType: "portal-user",
        redirectUri: window.location.origin,
        code: codeResponse.code,
      });
    },
    onError: (errorResponse) => {
      toast.error(errorResponse.error_description as string);
    },
  });

  return {signUpWithGoogle};
};
